import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { local_backend, openapikey } from "../../config";
import './conversation.scss'
import { BiArrowBack } from "react-icons/bi";
import formatMessage from "../../utils/formatMessage";

const Conversation = () => {
  const params = useParams();

  const [thread, setThread] = useState();
  const navigate = useNavigate();


  useEffect(() => {
    const listAllThreads = async () => {
      try {
        const response = await fetch(`${local_backend}OpenAPI/getByThreadId/${params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer sk-proj-${openapikey}`,
            "OpenAI-Beta": "assistants=v2"
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        data[0].messageContent.forEach(element => {
          element.messageResponse = formatMessage(element.messageResponse);
        });

        // data[0].messageContent?.reverse();

        setThread(data[0]);
      } catch (err) {
        const errorMessage = `Failed to initialize chat: ${err.message}`;
        console.error(errorMessage);
      }
    };

    listAllThreads();
  }, [params]);

  const goToThreads = () => {
    navigate(-1)
  }

  return (
    <div className="p-5 font-sofia">

      <div className="flex items-center gap-1 cursor-pointer text-left font-bold" onClick={() => { goToThreads() }}><BiArrowBack /> Chat Threads</div>

      <div className="messages-container">
        {thread?.messageContent?.map((message, index) => {
          return (<div key={`${message.role}-${index}`} className="flex-1 overflow-y-auto p-2 flex flex-col gap-2">
            <div

              className={`message bot-message`}
            >

              <div className="text-[14px] underline mb-1">User</div>
              <div>
                {
                  Array.isArray(message.messageRequest) ?
                    message.messageRequest.map((element) => {
                      return (
                        <p dangerouslySetInnerHTML={{ __html: element }}>
                        </p>
                      )
                    })
                    :
                    <p dangerouslySetInnerHTML={{ __html: message.messageRequest }}>
                    </p>
                }

              </div>
            </div>
            <div
              className={`message user-message`}
            >
              <div className="text-[14px] underline mb-1">Assistant</div>
              <div>
                {
                  Array.isArray(message.messageResponse) ?
                    message.messageResponse.map((element) => {
                      return (
                        <p dangerouslySetInnerHTML={{ __html: element }}>
                        </p>
                      )
                    })
                    :
                    <p dangerouslySetInnerHTML={{ __html: message.messageResponse }}>
                    </p>
                }

              </div>
            </div>
          </div>)
        })}
      </div>

    </div>
  );
};

export default Conversation;